
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.119 16.881l-2.882 2.881a.75.75 0 01-1.062 0l-6.937-6.937a.75.75 0 010-1.063l2.88-2.88a3.006 3.006 0 014.244 0l3.757 3.755a2.995 2.995 0 010 4.244zm-13.357-2.643L9.35 30.65l-1.325 7.594a1.502 1.502 0 001.737 1.737l7.594-1.331L33.77 22.238a.75.75 0 000-1.063l-6.938-6.938a.758.758 0 00-1.069 0zM15.756 29.244a.871.871 0 010-1.238l9.625-9.625a.871.871 0 011.238 0 .871.871 0 010 1.238l-9.625 9.625a.871.871 0 01-1.238 0zM13.5 34.5h3v2.269l-4.031.706-1.944-1.944.706-4.031H13.5v3z","fill":"#535353"}})])
          )
        }
      }
    